<template>
  <div class="help-card">
    <div class="help-card__title">
      <sc-text :field="fields.HelpTitle" />
    </div>
    <div class="help-card__content">
      <sc-rich-text v-if="isSitecoreExperienceEditor()" :field="fields.HelpContent" />
      <span v-if="!isSitecoreExperienceEditor()" v-html="replacePhoneNumber('HelpContent')" />
    </div>
  </div>
</template>

<script>
import { Text, RichText, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'HelpCard',
  data: function() {
    return {};
  },
  components: {
    ScText: Text,
    ScRichText: RichText,
  },
  methods: {
    replacePhoneNumber: function(fieldName) {
      // all dictionary entries available from
      // this.$i18n.i18next.services.backendConnector.store.data[this.$i18n.i18next.language].translation
      if (this.fields[fieldName] && this.fields[fieldName].value && this.$t) {
        return this.fields[fieldName].value.replace(
          /\$supportPhoneNumber/g,
          this.$t('supportPhoneNumber')
        );
      }
      return `<!-- Field '${fieldName}' not found -->`;
    },
    isSitecoreExperienceEditor() {
      return isExperienceEditorActive();
    },
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        HelpTitle: {
          value: 'Need assistance?',
        },
        HelpContent: {
          value:
            "Call our Investor Services team on $supportPhoneNumber Monday-Friday 8am-6pm AEST",
        },
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
.help-card {
  padding: 16px;
  background-color: #122656;

  &__title {
    color: white;
  }

  &__content {
    color: #7cadca;
  }
}
</style>
<style lang="scss">
.help-card__content a {
  color: white !important;
  text-decoration: none;
}
</style>
